import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from "../SnackBar";

export const PROFILES_PATCH_REQUEST = 'PATCH_PROFILES_REQUEST';
export const PROFILES_PATCH_FAILURE = 'PATCH_PROFILES_FAILURE';
export const PROFILES_PATCH_SUCCESS = 'PATCH_PROFILES_SUCCESS';

export const patchProfile = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.PROFILES.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                dispatch(addSuccessMessage('Profile successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => {
    return {
        type: PROFILES_PATCH_REQUEST,
    }
};

const postFailure = error => {
    return {
        type: PROFILES_PATCH_FAILURE,
        error,
    }
};

const patchSuccess = profile => {
    return {
        type: PROFILES_PATCH_SUCCESS,
        profile,
    }
};